(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["scroll-reveal-timeline"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('scroll-reveal-timeline')) {
    class ScrollRevealTimeline extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-timeline-item]'));
        this.track = this.querySelector('[data-timeline-track]');
        this.icons = Array.from(this.querySelectorAll('.scroll-timeline__icon'));
        this.frame = null;
        this.update = this.update.bind(this);
        this.queueUpdate = this.queueUpdate.bind(this);
        window.addEventListener('scroll', this.queueUpdate, { passive: true });
        window.addEventListener('resize', this.queueUpdate, { passive: true });
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.queueUpdate);
        window.removeEventListener('resize', this.queueUpdate);
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      queueUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(this.update);
      }

      update() {
        this.frame = null;
        const viewportHeight = window.innerHeight;
        const clearLine = viewportHeight * 0.68;
        const fadeLine = viewportHeight * 0.94;
        const range = fadeLine - clearLine;

        this.items.forEach((item) => {
          const center = item.getBoundingClientRect().top + Math.min(item.offsetHeight * 0.25, 48);
          const progress = Math.max(0, Math.min(1, (fadeLine - center) / range));
          item.style.setProperty('--reveal-progress', progress.toFixed(3));
        });

        if (this.track && this.icons.length > 1) {
          const listRect = this.track.parentElement.getBoundingClientRect();
          const firstRect = this.icons[0].getBoundingClientRect();
          const lastRect = this.icons[this.icons.length - 1].getBoundingClientRect();
          const trackTop = firstRect.top + (firstRect.height / 2);
          const trackBottom = lastRect.top + (lastRect.height / 2);
          const trackHeight = Math.max(0, trackBottom - trackTop);
          const trackLeft = firstRect.left + (firstRect.width / 2);
          const progress = trackHeight > 0
            ? Math.max(0, Math.min(1, (clearLine - trackTop) / trackHeight))
            : 0;

          this.track.style.top = `${trackTop - listRect.top}px`;
          this.track.style.left = `${trackLeft - listRect.left - (this.track.offsetWidth / 2)}px`;
          this.track.style.height = `${trackHeight}px`;
          this.track.style.setProperty('--track-fill', progress.toFixed(3));
        }
      }
    }

    customElements.define('scroll-reveal-timeline', ScrollRevealTimeline);
  }
  } catch(e) { console.error(e); }
})();

})();
